import React from 'react'
import Form from 'react-bootstrap/Form'
import {InputGroup} from 'react-bootstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface FieldInterface {
  as?: string,
  asGroup?: Object,
  defaultValue?: string,
  error?: boolean|string,
  label?: string,
  labelRequired?: boolean,
  classNames?: string,
  fieldClassNames?: string,
  name: string,
  onBlur?: Function,
  onChange: Function,
  onFocus?: Function,
  toggleAdornment?: Function,
  pattern?: string,
  placeholder?: string,
  rows?: number,
  success?: boolean,
  step?: string,
  style?: Object,
  type?: string,
  value: number|string,
  fieldRef?: Object,
  append?: string|node,
  prepend?: string|node,
  disabled?: boolean,
  readOnly?: boolean,
  min?: number|string,
  max?: number|string,
  maxLength?: number,
  helpContent?: string,
}

const Field = ({
  as,
  asGroup,
  rows,
  name,
  label,
  labelRequired,
  classNames,
  value,
  defaultValue,
  fieldClassNames,
  onBlur,
  onChange,
  style,
  onFocus,
  toggleAdornment,
  pattern,
  step,
  placeholder = '',
  type = 'text',
  error = '',
  success = '',
  fieldRef,
  append = null,
  prepend,
  disabled = false,
  readOnly = false,
  min,
  max,
  maxLength,
  helpContent,
}: FieldInterface) => (
  <Form.Group className={`${classNames} ${prepend && 'prepend'}`} as={asGroup}>
    {label && (
      <Form.Label htmlFor={name}>
        {label}
        {labelRequired && <span className="text-red"> *</span>}
      </Form.Label>
    )}
    <InputGroup>
      <Form.Control
        as={as}
        rows={rows}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        type={type}
        pattern={pattern}
        step={step}
        placeholder={placeholder || label}
        name={name}
        id={name}
        className={`${fieldClassNames} ${
          (error && 'is-invalid') || (success && 'is-valid')
        }`}
        style={style}
        ref={fieldRef}
        disabled={disabled}
        readOnly={readOnly}
        min={min}
        max={max}
        maxLength={maxLength}
      />
      {append &&
          <InputGroup.Text
             onClick={() => toggleAdornment()}
             className={'px-3'}
          >
            <FontAwesomeIcon icon={append} color='black' />
          </InputGroup.Text>
      }
      {error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      )}
    </InputGroup>
    {helpContent && (
        <Form.Text muted className={'text-right'}>
          {helpContent}
        </Form.Text>
    )}
  </Form.Group>
)

export default Field
